var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import styles from './DropDown.module.scss';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { onClickOutside } from 'src/shared/helpers/viewsHelpers';
import { IDENTIFIER_DROPDOWN, IDENTIFIER_DROPDOWN_OPTIONS } from 'src/ui/components/DropDown/constants';
export var DropDown = function (props) {
    var _a, _b;
    var label = props.label, children = props.children;
    var _c = useState(false), isImmersedVisible = _c[0], setIsImmersedVisible = _c[1];
    var dropDownRef = useRef(null);
    useEffect(function () {
        if (isImmersedVisible) {
            onClickOutside(dropDownRef, function () { return setIsImmersedVisible(false); });
        }
    }, [dropDownRef, isImmersedVisible]);
    var immersedClass = classNames(styles.dropDownImmersed, (_a = {},
        _a[styles.dropDownImmersedVisible] = isImmersedVisible,
        _a));
    var dropDownArrowClass = classNames(styles.dropDownArrowIcon, (_b = {},
        _b[styles.dropDownArrowForOpen] = isImmersedVisible,
        _b));
    return (_jsxs("div", __assign({ "data-test": IDENTIFIER_DROPDOWN, className: styles.dropDownWrapper, ref: dropDownRef }, { children: [_jsxs("div", __assign({ className: styles.dropDownEmerged, onClick: function () { return setIsImmersedVisible(!isImmersedVisible); } }, { children: [_jsx("span", __assign({ className: styles.dropDownEmergedLabel }, { children: label })), _jsx(Icons, { icon: E_ICONS.ARROW_RIGHT, className: dropDownArrowClass })] })), _jsx("div", __assign({ "data-test": IDENTIFIER_DROPDOWN_OPTIONS, className: immersedClass }, { children: children }))] })));
};
